enum APP_COLORS {
  // Base colors
  white = "#FFFFFF",
  black = "#000000",

  // PRIMARY (Blue tones from Figma - ordered from lightest to darkest)
  primaryLight = "#E8F0FA",
  primaryLight2 = "#C0D5F1",
  primaryLight3 = "#8EADD7",
  primaryLight4 = "#6183B2",
  primary = "#183866",
  primaryDark = "#041E42",
  primaryDark2 = "#03142B",
  primaryDark3 = "#030E1C",
  primaryDark4 = "#020A15",
  primaryDark5 = "#020810",

  // SECONDARY (Blue tones from Figma - ordered from lightest to darkest)
  secondaryLight = "#E8F5FF",
  secondaryLight2 = "#CEE9FF",
  secondaryLight3 = "#9ED4FF",
  secondaryLight4 = "#6BBDFF",
  secondary = "#36A2F9",
  secondaryDark = "#0072CE",
  secondaryDark2 = "#045699",
  secondaryDark3 = "#0C3C63",
  secondaryDark4 = "#082B48",
  secondaryDark5 = "#04121F",

  // GREY (from Figma - ordered from lightest to darkest)
  greyLight = "#F5F5F5",
  greyLight2 = "#EDEDED",
  greyLight3 = "#E1E4E8",
  greyLight4 = "#D0D4D9",
  greyLight5 = "#B9BEC4",
  greyLight6 = "#E1E4E8", // Alias for greyLight3 (backward compatibility)
  grey = "#A1A5AB",
  greyDark = "#83888F",
  greyDark2 = "#63686E",
  greyDark3 = "#42474F",
  greyDark4 = "#282B30",
  greyDark5 = "#EDEDED", // Alias for greyLight2 (backward compatibility)
  greyDark6 = "#83888F", // Alias for greyDark (backward compatibility)

  // TEXT (from Figma - ordered from lightest to darkest)
  textLight = "#BAB9BD",
  textLight2 = "#939394",
  textSecondary = "#66636B",
  textMedium = "#66636B", // Alias for textSecondary (backward compatibility)
  textMedium2 = "#3F3D42",
  textFieldLabelBlack = "#3F3D42",
  textDark6 = "#3F3D42",
  text = "#2C2A29",
  textDark = "#2C2A29",

  // ERROR/DANGEROUS (Red from Figma - ordered from lightest to darkest)
  errorLight = "#FFF3F5",
  errorLight2 = "#FFD7DD",
  errorLight3 = "#FFADBA",
  errorLight4 = "#FF798F",
  error = "#ED3D5A",
  errorDark = "#C8102E",
  errorDark2 = "#9E0B23",
  errorDark3 = "#710618",
  errorDark4 = "#4D0410",
  errorDark5 = "#270108",

  // SUCCESS (Green from Figma - ordered from lightest to darkest)
  successLight = "#F5FCF8",
  successLight2 = "#DCF7E8",
  successLight3 = "#C0F0D5",
  successLight4 = "#87E8B1",
  success = "#6EDB9D",
  successDark = "#009639",
  successDark2 = "#006C29",
  successDark3 = "#03471D",
  successDark4 = "#012A11",
  successDark5 = "#011D0C",

  // WARNING (Orange from Figma - ordered from lightest to darkest)
  yellowLight = "#FFF5EF",
  yellowLight2 = "#FFEADE",
  yellowLight3 = "#FFD4BC",
  yellowLight4 = "#FFB387",
  yellow = "#FF9355",
  yellowDark = "#FF6A13",
  yellowDark2 = "#D75509",
  yellowDark3 = "#983E09",
  yellowDark4 = "#642A08",
  yellowDark5 = "#321504",

  // INFO (Cyan from Figma - ordered from lightest to darkest)
  infoLight = "#EFFCFF",
  infoLight2 = "#D9F7FF",
  infoLight3 = "#C0F2FF",
  infoLight4 = "#98EAFF",
  infoLight5 = "#62DFFF",
  info = "#3DD3FA",
  infoDark = "#17C4F1",
  infoDark2 = "#00A4CF",
  infoDark3 = "#0091B7",
  infoDark4 = "#006782",

  // UI SPECIFIC COLORS (from codebase usage)
  // Header & Navigation
  headerDivider = "#183866",
  headerIconColor = "#C0D5F1",
  // Borders & Dividers
  borderLight = "#E0E0E0",
  borderLight2 = "#D9D9D9",
  borderLight3 = "#E5E7EB",
  borderLight4 = "#D0D4D9",
  borderMedium = "#828282",
  // Backgrounds
  backgroundLight = "#F2F3F8",
  backgroundLight2 = "#F2F2F2",
  backgroundLight3 = "#FBFBFB",
  backgroundLight4 = "#FAFAFA",
  backgroundLight5 = "#EDEFF2",
  backgroundLight6 = "#f5f7fb",
  backgroundLight7 = "#f2f3f9",
  backgroundLight8 = "#eef5ff",
  backgroundLight9 = "#fef2f2",
  backgroundLight10 = "#f0fdf4",
  backgroundLight11 = "#e8e8f2",
  backgroundLight12 = "#f3f3fd",
  backgroundLight13 = "#e9eafc",
  // Text & Labels
  textTableHeader = "#070639",
  textTableBody = "#828282",
  textMuted = "#6B778C",
  textMuted2 = "#C7C7CC",
  textMuted3 = "#4F4F4F",
  textMuted4 = "#1D1D1D",
  textMuted5 = "#63686e",
  textMuted6 = "#B9BEC4", // Alias for greyLight5 (backward compatibility)
  summaryLabelText = "#576572",
  summaryValueText = "#182027",
  textDark2 = "#0f172a",
  textDark3 = "#475569",
  // Status & Semantic Colors
  statusRed = "#EB5757",
  statusGreen = "#00A86B",
  statusGreen2 = "#31C197",
  statusBlue = "#0000ac",
  statusBlue2 = "#0000FF",
  statusBlue3 = "#1769aa",
  statusBlue4 = "#0060e6",
  statusBlue5 = "#2596be",
  statusOrange = "#FF9900",
  statusYellow = "#E2B93B",
  statusPurple = "#B031E3",
  statusGray = "#455A64",
  // Dark Colors
  darkBlue = "#1F416F",
  darkBlue2 = "#252F3E",
  darkGray = "#999999",
  darkGray2 = "#bdbdbd",

  // Light Accent Colors
  accentBlueLight = "#d6e5ec",
  accentBlueLight2 = "#ecf2fb",

  // Error/Red Variants
  errorRed = "#f44336",
  errorRedLight = "#e35335",

  // AI / Textarea suggestion (Figma)
  aiPurple = "#76118B",
  aiPurplePillBg = "#EDD8F2",
  aiPurpleTintBg = "rgba(187, 21, 220, 0.08)",
  aiButtonBg = "rgba(118, 17, 139, 0.1)",
  aiButtonBorder = "rgba(118, 17, 139, 0.15)",
  aiButtonHoverBg = "rgba(118, 17, 139, 0.18)",
  gradientViolet = "#6A2DE6",
  gradientMagenta = "#E70A74",
  gradientBlue = "#1D9DEE",

  // LEGACY/OTHER (kept for backward compatibility)
  checkbox_default = "#E8E6EB",
  purple = "#7642F2",
  orange = "#F5822E",
  invitationArchive = "#e3533599",
  sidebarTextLight = "#6183B2",
  inProgressDashboardIconColor = "#A77300",

  markAsDoneBgColor = "#EAFEFE",
  markAsDoneTextColor = "#36A6A6",
}

export { APP_COLORS };
